export default __webpack_public_path__ + "static/media/CreditsPhoto.3e2fde32.jpg";